import { GLOBAL } from 'saddlebag-browser';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { DeviceState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/device';

function getInitialState() {
  const $window = GLOBAL.getWindow();
  if (!$window?.__internal?.device) return {};

  const rawDevice = $window.__internal.device;

  return {
    browserName: rawDevice.browserName || 'unknown',
    browserVendor: rawDevice.browserVendor || 'unknown',
    browserVersion: rawDevice.browserVersion || 'unknown',
    isBrowser: rawDevice.isBrowser || false,
    isMobilePhone: rawDevice.isMobilePhone || false,
    isRobot: rawDevice.isRobot || false,
    isTablet: rawDevice.isTablet || false,
    marketingName: rawDevice.marketingName || 'unknown',
    model: rawDevice.model || 'unknown',
    osName: rawDevice.osName || 'unknown',
    osVersion: rawDevice.osVersion || 'unknown',
    primaryHardwareType: rawDevice.primaryHardwareType || 'unknown',
    prefersReducedMotion: $window.matchMedia('(prefers-reduced-motion)').matches,
    vendor: rawDevice.vendor || 'unknown',
  };
}

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const device = (state: DeviceState = getInitialState() as DeviceState, action: Action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default device;
export const get = (state: DeviceState): DeviceState => state;
